import { readingTime } from 'reading-time-estimator'

/* eslint-disable no-undef */
import './navigation-drawer'
import './navigation-dropdown'
import './cookies'

// Arrow Up Icon Button
const arrowUpIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.83301 14.1667L14.1663 5.83334M14.1663 5.83334H5.83301M14.1663 5.83334V14.1667" stroke="#05A6F0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document
  .querySelectorAll('.btn.contents__blog--cardReadMoreBtn')
  .forEach((el) => {
    el.innerHTML += arrowUpIcon
  })
document.querySelector('.btn.btn-book-demo').innerHTML += arrowUpIcon

const chevronDownIcon = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 4.5L6 7.5L9 4.5" stroke="#94A3B8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document.querySelectorAll('.link-item .arrow-down').forEach((el) => {
  el.innerHTML += chevronDownIcon
})

const hamburgerIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12H21M3 6H21M3 18H21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document.querySelector('.btn-hamburger').innerHTML += hamburgerIcon

const tabBlogCategories = document.querySelectorAll(
  '.btn.contents__blog--tabButton',
)
tabBlogCategories.forEach((el) => {
  el.addEventListener('click', () => {
    tabBlogCategories.forEach((el) => {
      el.classList.remove('active')
    })

    el.classList.add('active')
  })
})

// Get Data Strapi
const myHeaders = new Headers()
myHeaders.append('Authorization', `Bearer ${process.env.VERCEL_STRAPI_TOKEN}`)

const requestOptions = {
  method: 'GET',
  headers: myHeaders,
  redirect: 'follow',
}

function resolveRichText(nodes) {
  return nodes.map((c) => resolveRichTextNode(c)).join('')
}

function resolveRichTextNode(node) {
  let html = ''
  const children = node.children
    ? node.children.map((c) => resolveRichTextNode(c)).join('')
    : ''

  switch (node.type) {
    case 'heading':
      html = `<h${node.level}>${children}</h${node.level}>`
      break
    case 'text':
      if (node.text) {
        let tmp = node.text.replaceAll('\n', '<br />')

        if (node.bold) tmp = `<b>${tmp}</b>`
        if (node.code) tmp = `<code>${tmp}</code>`
        if (node.italic) tmp = `<i>${tmp}</i>`
        if (node.strikethrough) tmp = `<s>${tmp}</s>`
        if (node.underline) tmp = `<u>${tmp}</u>`

        html = tmp
      }
      break
    case 'paragraph':
      html = `<p>${children}</p>`
      break
    case 'link':
      html = `<a href="${node.url}">${children}</a>`
      break
    case 'list':
      switch (node.format) {
        case 'ordered':
          html = `<ol>${children}</ol>`
          break
        case 'unordered':
          html = `<ul>${children}</ul>`
          break
      }
      break
    case 'list-item':
      html = `<li>${children}</li>`
      break
    case 'quote':
      html = `<blockquote>${children}</blockquote>`
      break
    case 'code':
      html = `<pre>${children}</pre>`
      break
    case 'image':
      if (node.image) {
        html = `<img src="${node.image.url}" height="${node.image.height}" width="${node.image.width}" alt="${node.image.alternativeText}" />`
      }
      break
  }

  return html
}

const featuredBlogHero = (datas) => {
  console.log(datas)
  const data = datas[0].attributes
  const heroElement = document.querySelector('.hero__blog--featured')
  heroElement.querySelector(
    '[data-element="hero-blog-title-featured"]',
  ).innerHTML = data?.Title
  heroElement.querySelector(
    '[data-element="hero-blog-desc-featured"]',
  ).innerHTML = data?.Detail
  heroElement
    .querySelector('[data-element="hero-blog-desc-url-link"]')
    .setAttribute(
      'onclick',
      `location.href = "${process.env.VERCEL_BASE_URL}/blog-detail.html?blogId=${datas[0].id}";`,
    )
}

const featuredLargeBlog = (datas) => {
  const data = datas[0].attributes
  const cardElement = document.querySelector(
    '.contents__blog--card.featuredLarge[data-element="blog-card"]',
  )
  cardElement
    .querySelector('[data-element="url-link-image"]')
    .setAttribute(
      'href',
      `${process.env.VERCEL_BASE_URL}/blog-detail.html?blogId=${datas[0].id}`,
    )
  cardElement.querySelector('[data-element="url-link-image"] img').src =
    data.cover.data.attributes.url
      .replace('/upload', '/upload/q_auto:eco')
      .replace('.png', '.webp')
  cardElement.querySelector('[data-element="created-date"]').innerHTML = moment(
    data.publishedAt,
  ).format('MMM. DD,Y')
  cardElement.querySelector('[data-element="reading-time"]').innerHTML =
    readingTime(resolveRichText(data.contents), 300).text
  cardElement.querySelector('[data-element="title"]').innerHTML = data?.Title
  cardElement.querySelector('[data-element="description"]').innerHTML =
    data?.Detail
  cardElement
    .querySelector('[data-element="readMore-link"]')
    .setAttribute(
      'href',
      `${process.env.VERCEL_BASE_URL}/blog-detail.html?blogId=${datas[0].id}`,
    )
}
const featuredSmallsBlog = (datas) => {
  const featuredSmalls = document.querySelector(
    '.contents__blog--featuredSmalls',
  )

  const _datas = datas.slice(1, 4)
  _datas.forEach((_data) => {
    const data = _data.attributes
    const cardElement = featuredSmalls
      .querySelector('[data-element="blog-card"]')
      .cloneNode(true)
    cardElement
      .querySelector('[data-element="url-link-image"]')
      .setAttribute(
        'href',
        `${process.env.VERCEL_BASE_URL}/blog-detail.html?blogId=${_data.id}`,
      )
    cardElement.querySelector('[data-element="url-link-image"] img').src =
      data.cover.data.attributes.url
        .replace('/upload', '/upload/q_auto:eco')
        .replace('.png', '.webp')
    cardElement.querySelector('[data-element="created-date"]').innerHTML =
      moment(data.publishedAt).format('MMM. DD,Y')
    cardElement.querySelector('[data-element="reading-time"]').innerHTML =
      readingTime(resolveRichText(data.contents), 300).text
    cardElement.querySelector('[data-element="title"]').innerHTML = data?.Title
    cardElement.querySelector('[data-element="description"]').innerHTML =
      data?.Detail
    cardElement
      .querySelector('[data-element="readMore-link"]')
      .setAttribute(
        'href',
        `${process.env.VERCEL_BASE_URL}/blog-detail.html?blogId=${_data.id}`,
      )

    featuredSmalls.appendChild(cardElement)
  })
  featuredSmalls.querySelectorAll('[data-element="blog-card"]')[0].remove()
}
const gridListBlogs = (datas) => {
  const gridBlogs = document.querySelector('.contents__blog--cards')

  const _datas = datas.slice(4)
  _datas.forEach((_data) => {
    const data = _data.attributes
    const cardElement = gridBlogs
      .querySelector('[data-element="blog-card"]')
      .cloneNode(true)
    cardElement
      .querySelector('[data-element="url-link-image"]')
      .setAttribute(
        'href',
        `${process.env.VERCEL_BASE_URL}/blog-detail.html?blogId=${_data.id}`,
      )
    cardElement.querySelector('[data-element="url-link-image"] img').src =
      data.cover.data.attributes.url
        .replace('/upload', '/upload/q_auto:eco')
        .replace('.png', '.webp')
    cardElement.querySelector('[data-element="created-date"]').innerHTML =
      moment(data.publishedAt).format('MMM. DD,Y')
    cardElement.querySelector('[data-element="reading-time"]').innerHTML =
      readingTime(resolveRichText(data.contents), 300).text
    cardElement.querySelector('[data-element="title"]').innerHTML = data?.Title
    cardElement.querySelector('[data-element="description"]').innerHTML =
      data?.Detail
    cardElement
      .querySelector('[data-element="readMore-link"]')
      .setAttribute(
        'href',
        `${process.env.VERCEL_BASE_URL}/blog-detail.html?blogId=${_data.id}`,
      )

    gridBlogs.appendChild(cardElement)
  })
  gridBlogs.querySelectorAll('[data-element="blog-card"]')[0].remove()
}

const queryString = window.location.search
const urlParams = new URLSearchParams(queryString)
const page = urlParams.get('page') ?? 1
const category = urlParams.get('category') ?? 'blog-articles'

const createElementPagination = (pagination) => {
  const blogPagination = document.querySelector('[data-element="pagination"]')
  const paginationGroup = blogPagination.querySelector(
    '[data-element="pagination-group"]',
  )

  for (let index = 0; index < pagination.pageCount; index++) {
    const paginationButton = blogPagination
      .querySelector('[data-element="pagination-button"]')
      .cloneNode(true)
    paginationButton.textContent = index + 1
    urlParams.set('page', index + 1)
    paginationButton.setAttribute(
      'onclick',
      `window.location.href="${process.env.VERCEL_BASE_URL}/blog.html?${urlParams.toString()}#blogContent";`,
    )
    paginationGroup.appendChild(paginationButton)
  }

  if (pagination.page > 1) {
    urlParams.set('page', pagination.page - 1)
    blogPagination
      .querySelector('[data-element="pagination-left"]')
      .setAttribute(
        'onclick',
        `window.location.href="${process.env.VERCEL_BASE_URL}/blog.html?${urlParams.toString()}#blogContent";`,
      )
  }
  if (pagination.page === 1) {
    blogPagination
      .querySelector('[data-element="pagination-left"]')
      .classList.add('disabled')
  }

  if (pagination.page < pagination.pageCount) {
    urlParams.set('page', pagination.page + 1)
    blogPagination
      .querySelector('[data-element="pagination-right"]')
      .setAttribute(
        'onclick',
        `window.location.href="${process.env.VERCEL_BASE_URL}/blog.html?${urlParams.toString()}#blogContent";`,
      )
  }
  if (pagination.page === pagination.pageCount) {
    blogPagination
      .querySelector('[data-element="pagination-right"]')
      .classList.add('disabled')
  }

  blogPagination
    .querySelectorAll('[data-element="pagination-button"]')[0]
    .remove()
  blogPagination
    .querySelectorAll('[data-element="pagination-button"]')
    [pagination.page - 1].classList.add('active')
}

document.querySelectorAll('[data-element="blog-tabs"] button').forEach((el) => {
  el.addEventListener('click', (ev) => {
    // urlParams.set('category', el.getAttribute('data-element'))
    window.location.href = `${process.env.VERCEL_BASE_URL}/blog.html?category=${el.getAttribute('data-element')}#blogContent`
  })
})
document.querySelectorAll('[data-element="blog-tabs"] button').forEach((el) => {
  if (el.getAttribute('data-element') === category) {
    el.classList.add('active')
  }
})

fetch(
  `${process.env.VERCEL_STRAPI_URL}/api/blogs?populate=*&sort=id&pagination[page]=${page}&pagination[pageSize]=13&filters[blog_category][slug][$eq]=${category}`,
  requestOptions,
)
  .then((response) => response.json())
  .then((result) => {
    // console.log(result)
    // featuredLargeBlog(result.data)
    // featuredSmallsBlog(result.data)
    // gridListBlogs(result.data)
    // createElementPagination(result.meta.pagination)
    // document.querySelectorAll('[data-element="blog-card"]').forEach(el => {
    //   el.style.display = 'flex'
    // })

    if (result.data.length === 0) {
      document.querySelector('[data-element="blog-not-found"]').style.display =
        'block'
      document.querySelector('[data-element="pagination"]').style.display =
        'none'
    } else {
      featuredLargeBlog(result.data)
      featuredSmallsBlog(result.data)
      gridListBlogs(result.data)
      createElementPagination(result.meta.pagination)
      document.querySelectorAll('[data-element="blog-card"]').forEach((el) => {
        el.style.display = 'flex'
      })
      document.querySelector('[data-element="pagination"]').style.display =
        'flex'
    }
  })
  .catch((error) => console.error(error))

fetch(
  `${process.env.VERCEL_STRAPI_URL}/api/blogs?populate=*&filters[featured][$eq]=true`,
  requestOptions,
)
  .then((response) => response.json())
  .then((result) => {
    // if (result.data.length === 0) {
    // document.querySelector('[data-element="blog-not-found"]').style.display = 'block'
    // document.querySelector('[data-element="pagination"]').style.display = 'none'
    // } else {
    featuredBlogHero(result.data)
    // featuredLargeBlog(result.data)
    // featuredSmallsBlog(result.data)
    // gridListBlogs(result.data)
    // createElementPagination(result.meta.pagination)
    // document.querySelectorAll('[data-element="blog-card"]').forEach(el => {
    //   el.style.display = 'flex'
    // })
    // document.querySelector('[data-element="pagination"]').style.display = 'flex'
    // }
  })
  .catch((error) => console.error(error))

// Dropdown Product
const dropdownProduct = document.querySelector(
  '[data-element="dropdown-product"]',
)
dropdownProduct
  .querySelector('[data-element="dropdown-btn"]')
  .addEventListener('click', (el) => {
    if (
      dropdownProduct
        .querySelector('[data-element="dropdown-content"]')
        .classList.contains('hide')
    ) {
      dropdownProduct
        .querySelector('[data-element="dropdown-content"]')
        .classList.remove('hide')
      dropdownProduct.querySelector(
        '[data-element="dropdown-btn-arrow"]',
      ).style.rotate = '180deg'
    } else {
      dropdownProduct
        .querySelector('[data-element="dropdown-content"]')
        .classList.add('hide')
      dropdownProduct.querySelector(
        '[data-element="dropdown-btn-arrow"]',
      ).style.rotate = '0deg'
    }
  })
dropdownProduct
  .querySelectorAll('[data-element="dropdown-btn-item"]')
  .forEach((elBtn) => {
    if (elBtn.getAttribute('data-select') === category) {
      dropdownProduct.querySelector(
        '[data-element="dropdown-btn"] p',
      ).textContent = elBtn.querySelector('p').textContent
    }

    elBtn.addEventListener('click', (ev) => {
      const textSelection = elBtn.querySelector('p').textContent
      dropdownProduct.querySelector(
        '[data-element="dropdown-btn"] p',
      ).textContent = textSelection

      dropdownProduct
        .querySelector('[data-element="dropdown-content"]')
        .classList.add('hide')
      dropdownProduct.querySelector(
        '[data-element="dropdown-btn-arrow"]',
      ).style.rotate = '0deg'

      window.location.href = `${process.env.VERCEL_BASE_URL}/blog.html?category=${elBtn.getAttribute('data-select')}#blogContent`
      // availableProductsEl.querySelectorAll('.available-products--content-item').forEach(elContent => {
      //   elContent.style.display = 'none'

      //   if (elBtn.getAttribute('data-select') === elContent.getAttribute('data-tab')) {
      //     elContent.style.display = 'flex'
      //   }
      // })
    })
  })
